import './customer.address';
import './customer.email-updater';
import './customer.last-order';
import './customer.password-recovery';
import './customer.password-updater';
import './locations.browser';
import './order.address';
import './order.delivery-fee';
import './order.discounts-total';
import './order.location';
import './order.method';
import './order.minutes-to-closing';
import './order.online-payment.redirect-form';
import './order.products';
import './order.progress';
import './order.progress-errors';
import './order.surcharge';
import './order.tip';
import './policies';
